// John Eldhose 20180511
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const store = () => {
  const initialState = {
    Languages: [
      {value: 'en_US', label: 'English'},
      {value: 'es_ES', label: 'Español'},
      {value: 'ru_RU', label: 'Russian'}
    ],
    LanguageSelected: 'en_US',
    LMDCache: {},
    ShoppingCart: {}
  }
  return createStore(rootReducer, initialState, applyMiddleware(thunk));
}

export default store();



// WEBPACK FOOTER //
// ./src/store.js